'use client';

import React, { useState } from 'react';
import { useBookProStore } from '@/store/useLocaleBookProStore';

function ActionWidget() {
  const { resetForm, sessionId } = useBookProStore();
  const [showTooltip, setShowTooltip] = useState(null);
  const [copied, setCopied] = useState(false);

  const handleResetQuiz = () => {
    if (window.confirm('Are you sure you want to reset the quiz? All your progress will be lost.')) {
      resetForm();
    }
  };

  // Copy Session ID to clipboard
  const handleCopySessionId = async () => {
    if (!sessionId) {
      console.warn('No session ID available to copy');
      return;
    }

    try {
      await navigator.clipboard.writeText(sessionId);
      console.log('✅ Session ID copied to clipboard:', sessionId);
      setCopied(true);

      // Reset copied state after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy session ID:', error);
      // Fallback for older browsers
      try {
        const textArea = document.createElement('textarea');
        textArea.value = sessionId;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        console.log('✅ Session ID copied to clipboard (fallback):', sessionId);
        setCopied(true);
        setTimeout(() => {
          setCopied(false);
        }, 2000);
      } catch (fallbackError) {
        console.error('Fallback copy also failed:', fallbackError);
      }
    }
  };

  const handleAction2 = () => {
    console.log('Action 2 clicked - Placeholder');
    // TODO: Implement action 2
  };

  return null;

  // Temporarily removed fixed buttons
  /*
  return (
    <div className="fixed bottom-24 right-4 md:bottom-28 md:right-6 z-40 flex flex-col gap-3">
      {/* Copy Session ID Button *\/}
      <div className="relative group">
        <button
          onClick={handleCopySessionId}
          onMouseEnter={() => setShowTooltip('copySession')}
          onMouseLeave={() => setShowTooltip(null)}
          className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 hover:scale-110 border ${
            copied
              ? 'bg-green-500 border-green-600'
              : 'bg-white hover:bg-gray-50 border-gray-200'
          }`}
          aria-label="Copy Session ID"
          disabled={!sessionId}
        >
          {copied ? (
            // Checkmark icon when copied
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5 13l4 4L19 7"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            // Copy/Clipboard icon
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="9"
                y="9"
                width="13"
                height="13"
                rx="2"
                stroke="#6B7280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5"
                stroke="#6B7280"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </button>
        {(showTooltip === 'copySession' || copied) && (
          <div className={`absolute right-full mr-3 top-1/2 -translate-y-1/2 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap ${
            copied ? 'bg-green-500' : 'bg-gray-800'
          }`}>
            {copied ? 'Copied!' : 'Copy Session ID'}
            <div className={`absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent ${
              copied ? 'border-l-green-500' : 'border-l-gray-800'
            }`}></div>
          </div>
        )}
      </div>

      {/* Action Button 2 - Placeholder *\/}
      <div className="relative group">
        <button
          onClick={handleAction2}
          onMouseEnter={() => setShowTooltip('action2')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-14 h-14 bg-white rounded-full shadow-lg flex items-center justify-center hover:bg-gray-50 transition-all duration-200 hover:scale-110 border border-gray-200"
          aria-label="Action 2"
        >
          {/* Placeholder Icon *\/}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" />
            <path d="M12 8V12M12 16H12.01" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
        {showTooltip === 'action2' && (
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap">
            Action 2
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-800"></div>
          </div>
        )}
      </div>

      {/* Reset Quiz Button *\/}
      <div className="relative group">
        <button
          onClick={handleResetQuiz}
          onMouseEnter={() => setShowTooltip('reset')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-14 h-14 bg-orange rounded-full shadow-lg flex items-center justify-center hover:bg-orange/90 transition-all duration-200 hover:scale-110"
          aria-label="Reset Quiz"
        >
          {/* Refresh/Reset Icon *\/}
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 12C4 7.58172 7.58172 4 12 4C14.5264 4 16.7792 5.17108 18.2454 7M20 12C20 16.4183 16.4183 20 12 20C9.47362 20 7.22075 18.8289 5.75463 17"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              d="M18 3V7H14M6 21V17H10"
              stroke="white"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        {showTooltip === 'reset' && (
          <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-gray-800 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap">
            Reset Quiz
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full border-8 border-transparent border-l-gray-800"></div>
          </div>
        )}
      </div>
    </div>
  );
  */
}

export default ActionWidget;
